package store.actions

import it.neckar.common.redux.ChangeType
import it.neckar.lizergy.model.project.ProjectConfiguration.PhotovoltaicsProjectId
import it.neckar.lizergy.model.stumps.Documentation
import store.PlannerClientState

/**
 * Updates a single project.
 * Does *not* navigate to the project
 */
data class UpdateDocumentationAction(val projectId: PhotovoltaicsProjectId, val updatedDocumentation: Documentation) : StateAction {
  override val type: ChangeType = ChangeType.HistoryReset

  override fun PlannerClientState.updateState(): PlannerClientState {
    println("Updating Documentation <${updatedDocumentation.uuid}> for project <${projectId}>")

    val resolvedProject = this.resolvedProjects[projectId]
    val updatedProject = resolvedProject.copy(documentation = updatedDocumentation)

    val updatedProjects = this.resolvedProjects.withUpdated(updatedProject)

    return this.copy(resolvedProjects = updatedProjects)
  }
}
